import http from '~/common/http'
export default {
    // 销售提成业绩
    getView(params) {
        return http.get('/api/count-config/view', {
            params: params
        });
    },

    create(data) {
        return http.post("/api/count-config/create", data);
    },

    update(data) {
        return http.put("/api/count-config/update", data);
    },
}


// WEBPACK FOOTER //
// ./src/services/CountConfig.js